// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as base64 from "base64-js";
import JSZip from "jszip";
import { section1mPath, uint8ArrayType, emptyValue, textResultType, formulaSectionNotFoundErr, xmlTextResultType, element, section1PathPrefix, divider, elementAttributes, elementAttributesValues, } from "./constants";
import { arrayUtils } from ".";
export var replaceSingleQuery = function (base64Str, queryName, queryMashupDoc) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, version, packageOPC, permissionsSize, permissions, metadata, endBuffer, newPackageBuffer, packageSizeBuffer, permissionsSizeBuffer, newMetadataBuffer, metadataSizeBuffer, newMashup;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getPackageComponents(base64Str), version = _a.version, packageOPC = _a.packageOPC, permissionsSize = _a.permissionsSize, permissions = _a.permissions, metadata = _a.metadata, endBuffer = _a.endBuffer;
                return [4 /*yield*/, editSingleQueryPackage(packageOPC, queryMashupDoc)];
            case 1:
                newPackageBuffer = _b.sent();
                packageSizeBuffer = arrayUtils.getInt32Buffer(newPackageBuffer.byteLength);
                permissionsSizeBuffer = arrayUtils.getInt32Buffer(permissionsSize);
                newMetadataBuffer = editSingleQueryMetadata(metadata, { queryName: queryName });
                metadataSizeBuffer = arrayUtils.getInt32Buffer(newMetadataBuffer.byteLength);
                newMashup = arrayUtils.concatArrays(version, packageSizeBuffer, newPackageBuffer, permissionsSizeBuffer, permissions, metadataSizeBuffer, newMetadataBuffer, endBuffer);
                return [2 /*return*/, base64.fromByteArray(newMashup)];
        }
    });
}); };
export var getPackageComponents = function (base64Str) {
    var buffer = base64.toByteArray(base64Str).buffer;
    var mashupArray = new arrayUtils.ArrayReader(buffer);
    var version = mashupArray.getBytes(4);
    var packageSize = mashupArray.getInt32();
    var packageOPC = mashupArray.getBytes(packageSize);
    var permissionsSize = mashupArray.getInt32();
    var permissions = mashupArray.getBytes(permissionsSize);
    var metadataSize = mashupArray.getInt32();
    var metadata = mashupArray.getBytes(metadataSize);
    var endBuffer = mashupArray.getBytes();
    return {
        version: version,
        packageOPC: packageOPC,
        permissionsSize: permissionsSize,
        permissions: permissions,
        metadata: metadata,
        endBuffer: endBuffer,
    };
};
var editSingleQueryPackage = function (packageOPC, queryMashupDoc) { return __awaiter(void 0, void 0, void 0, function () {
    var packageZip;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, JSZip.loadAsync(packageOPC)];
            case 1:
                packageZip = _a.sent();
                setSection1m(queryMashupDoc, packageZip);
                return [4 /*yield*/, packageZip.generateAsync({ type: uint8ArrayType })];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var setSection1m = function (queryMashupDoc, zip) {
    var _a;
    if (!((_a = zip.file(section1mPath)) === null || _a === void 0 ? void 0 : _a.async(textResultType))) {
        throw new Error(formulaSectionNotFoundErr);
    }
    var newSection1m = queryMashupDoc;
    zip.file(section1mPath, newSection1m, {
        compression: emptyValue,
    });
};
export var editSingleQueryMetadata = function (metadataArray, metadata) {
    //extract metadataXml
    var mashupArray = new arrayUtils.ArrayReader(metadataArray.buffer);
    var metadataVersion = mashupArray.getBytes(4);
    var metadataXmlSize = mashupArray.getInt32();
    var metadataXml = mashupArray.getBytes(metadataXmlSize);
    var endBuffer = mashupArray.getBytes();
    //parse metdataXml
    var textDecoder = new TextDecoder();
    var metadataString = textDecoder.decode(metadataXml);
    var parser = new DOMParser();
    var serializer = new XMLSerializer();
    var parsedMetadata = parser.parseFromString(metadataString, xmlTextResultType);
    // Update InfoPaths to new QueryName
    var itemPaths = parsedMetadata.getElementsByTagName(element.itemPath);
    if (itemPaths && itemPaths.length) {
        for (var i = 0; i < itemPaths.length; i++) {
            var itemPath = itemPaths[i];
            var content = itemPath.innerHTML;
            if (content.includes(section1PathPrefix)) {
                var strArr = content.split(divider);
                strArr[1] = encodeURIComponent(metadata.queryName);
                var newContent = strArr.join(divider);
                itemPath.textContent = newContent;
            }
        }
    }
    var entries = parsedMetadata.getElementsByTagName(element.entry);
    if (entries && entries.length) {
        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            var entryAttributes = entry.attributes;
            var entryAttributesArr = __spreadArray([], entryAttributes, true);
            var entryProp = entryAttributesArr.find(function (prop) {
                return (prop === null || prop === void 0 ? void 0 : prop.name) === elementAttributes.type;
            });
            if ((entryProp === null || entryProp === void 0 ? void 0 : entryProp.nodeValue) == elementAttributes.resultType) {
                entry.setAttribute(elementAttributes.value, elementAttributesValues.tableResultType());
            }
            if ((entryProp === null || entryProp === void 0 ? void 0 : entryProp.nodeValue) == elementAttributes.fillLastUpdated) {
                var nowTime = new Date().toISOString();
                entry.setAttribute(elementAttributes.value, (elementAttributes.day + nowTime).replace(/Z/, "0000Z"));
            }
        }
    }
    // Convert new metadataXml to Uint8Array
    var newMetadataString = serializer.serializeToString(parsedMetadata);
    var encoder = new TextEncoder();
    var newMetadataXml = encoder.encode(newMetadataString);
    var newMetadataXmlSize = arrayUtils.getInt32Buffer(newMetadataXml.byteLength);
    var newMetadataArray = arrayUtils.concatArrays(metadataVersion, newMetadataXmlSize, newMetadataXml, endBuffer);
    return newMetadataArray;
};
